import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import BackButton from "../components/BackButton";

const GradientGenerator = () => {
  const [colors, setColors] = useState(['#ff0000', '#0000ff']);
  const [gradientType, setGradientType] = useState('linear');
  const [angle, setAngle] = useState(90);

  const handleColorChange = (index, value) => {
    const newColors = [...colors];
    newColors[index] = value;
    setColors(newColors);
  };

  const addColor = () => setColors([...colors, '#ffffff']);

  const removeColor = (index) => {
    if (colors.length > 2) {
      setColors(colors.filter((_, i) => i !== index));
    }
  };

  const gradientCSS =
    gradientType === 'linear'
      ? `linear-gradient(${angle}deg, ${colors.join(', ')})`
      : gradientType === 'radial'
      ? `radial-gradient(${colors.join(', ')})`
      : `conic-gradient(from ${angle}deg, ${colors.join(', ')})`;

  const copyToClipboard = () => {
    navigator.clipboard.writeText(`background: ${gradientCSS};`);
    alert('CSS copied to clipboard!');
  };

  return (
    <>
      <Helmet>
        <title>Gradient Generator Tool - Create CSS Gradients</title>
        <meta
          name="description"
          content="Generate CSS gradients with multiple color stops. Customize type, angle, and copy CSS code instantly."
        />
        <meta name="keywords" content="gradient generator, css gradient tool, linear gradient, radial gradient, conic gradient, gradient angle" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://freelity.com/gradient-generator" />
      </Helmet>

      <section className="sec-free-tools">
        <div className="container">
          <BackButton />
          <h2>Gradient Generator Tool</h2>

          <div className="mb-3">
            <label className="form-label">Gradient Type</label>
            <select
              className="form-select"
              value={gradientType}
              onChange={(e) => setGradientType(e.target.value)}
            >
              <option value="linear">Linear</option>
              <option value="radial">Radial</option>
              <option value="conic">Conic</option>
            </select>
          </div>

          {(gradientType === 'linear' || gradientType === 'conic') && (
            <div className="mb-3">
              <label className="form-label">Angle (in degrees)</label>
              <input
                type="number"
                className="form-control"
                value={angle}
                onChange={(e) => setAngle(Number(e.target.value))}
                min="0"
                max="360"
              />
            </div>
          )}

          {colors.map((color, index) => (
            <div className="mb-3 d-flex align-items-center gap-2" key={index}>
              <input
                type="color"
                value={color}
                onChange={(e) => handleColorChange(index, e.target.value)}
                className="form-control form-control-color"
              />
              <input
                type="text"
                value={color}
                onChange={(e) => handleColorChange(index, e.target.value)}
                className="form-control"
                placeholder="#ffffff"
                maxLength="7"
              />
              {colors.length > 2 && (
                <button className="btn btn-danger" onClick={() => removeColor(index)}>
                  Remove
                </button>
              )}
            </div>
          ))}

          <button className="btn btn-primary mb-3" onClick={addColor}>
            Add Color
          </button>

          <div
            className="mb-3"
            style={{
              height: '150px',
              background: gradientCSS,
              border: '1px solid #ccc',
            }}
          ></div>

          <div className="mb-3">
            <label className="form-label">Generated CSS</label>
            <textarea
              className="form-control"
              rows="3"
              value={`background: ${gradientCSS};`}
              readOnly
            />
          </div>

          <button className="btn btn-success" onClick={copyToClipboard}>
            Copy CSS
          </button>
        </div>
      </section>
    </>
  );
};

export default GradientGenerator;
